import { LotType } from './lot';
import cremationPlot from 'src/assets/images/cremation-plot.png';
import crypt from 'src/assets/images/crypt.png';
import greenBurial from 'src/assets/images/green-burial.png';
import infant from 'src/assets/images/infant.png';
import niche from 'src/assets/images/niche.png';
import ossuary from 'src/assets/images/ossuary.png';
import plot from 'src/assets/images/plot.png';

export const NoImageLot = {
  [LotType.PLOT]: plot,
  [LotType.CREMATION_PLOT]: cremationPlot,
  [LotType.NICHE]: niche,
  [LotType.CRYPT]: crypt,
  [LotType.GREEN_BURIAL]: greenBurial,
  [LotType.OSSUARY]: ossuary,
  [LotType.INFANT]: infant,
};
